import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function AppLogin({ onSignup }: { onSignup: () => void }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit() {
    if (busy) return;
    setError(null);
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (e: any) {
      setError(e?.message || 'Login failed. Check your email and password.');
    } finally {
      setBusy(false);
    }
  }

  const inputStyle = { backgroundColor: '#15122e', border: '1px solid rgba(255,255,255,0.08)', color: 'white' } as const;

  return (
    <div className="fixed inset-0 flex flex-col justify-center px-6 text-white"
      style={{
        fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
        backgroundColor: '#0A0918',
        backgroundImage:
          'radial-gradient(at 18% 14%, rgba(139,92,246,0.25) 0, transparent 48%),' +
          'radial-gradient(at 82% 16%, rgba(236,72,153,0.20) 0, transparent 48%)',
      }}>
      <div className="text-2xl font-bold mb-1 text-center" style={{ fontFamily: '"Space Grotesk", sans-serif', background: 'linear-gradient(135deg,#8B5CF6,#EC4899)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
        AltCoinsMoney
      </div>
      <h1 className="text-3xl font-bold text-center" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>Welcome back</h1>
      <p className="text-center text-sm mb-7" style={{ color: '#8B82A8' }}>Sign in to your account</p>

      <label className="text-sm mb-1 block" style={{ color: '#c4b5fd' }}>Email</label>
      <input value={email} onChange={(e) => setEmail(e.target.value)} autoCapitalize="none" autoCorrect="off" inputMode="email"
        className="w-full rounded-2xl px-4 py-3 mb-4 outline-none" style={inputStyle} />

      <label className="text-sm mb-1 block" style={{ color: '#c4b5fd' }}>Password</label>
      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && submit()}
        className="w-full rounded-2xl px-4 py-3 mb-4 outline-none" style={inputStyle} />

      {error && <div className="rounded-2xl px-4 py-3 mb-4 text-sm" style={{ backgroundColor: 'rgba(248,113,113,0.12)', color: '#F87171' }}>{error}</div>}

      <button onClick={submit} disabled={busy} className="w-full rounded-2xl py-3.5 font-semibold text-white" style={{ background: 'linear-gradient(135deg,#8B5CF6,#EC4899)', opacity: busy ? 0.6 : 1 }}>
        {busy ? 'Signing in…' : 'Sign in'}
      </button>

      <button onClick={onSignup} className="w-full mt-3 text-sm" style={{ color: '#8B82A8' }}>
        No account? <span style={{ color: '#c4b5fd' }}>Create one</span>
      </button>
    </div>
  );
}